import { ArquivoUpload } from './arquivo-upload';

export class ArquivoBulkUpload {
    uploads: ArquivoUpload[];

    constructor(uploads: ArquivoUpload[]) {
        this.uploads = uploads;
    }
}
